import { useContext } from "react";
import { CircularProgress } from "@mui/material";
import { usePageTitle } from "../../common/hooks/usePageTitle";
import { Order } from "../../components/Order";
import { OrderContext } from "../../context/Order/OrderContext";
import { palette } from "../../styles/theme";
import { Box, Link } from "../../common/components";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../constant/common.constant";

const UserOrder = () => {
  usePageTitle("pages.order.title");
  const { isOrderLoaded } = useContext(OrderContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const from = location.state?.from;

  return (
    <Box
      sx={{
        backgroundColor: palette.grey.lightBackground,
        minHeight: "100vh",
        width: "100%",
        pt: "24px",
        px: "24px",
        pb: "48px",
      }}
    >
      <Box maxWidth={"fit-content"} mb="16px">
        <Link
          startIcon="keyboard_arrow_left"
          onClick={() => {
            if (!from) {
              navigate(ROUTES.ORDERS);
            } else {
              navigate(-1);
            }
          }}
        >
          {t("general.back")}
        </Link>
      </Box>
      {isOrderLoaded ? (
        <Order />
      ) : (
        <div>
          <CircularProgress />
        </div>
      )}
    </Box>
  );
};

export default UserOrder;
